import { render, staticRenderFns } from "./LvChecklistCollapseList.vue?vue&type=template&id=35a6432a"
import script from "./LvChecklistCollapseList.vue?vue&type=script&lang=js"
export * from "./LvChecklistCollapseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports